export default "__VITE_ASSET__04da10ef__"